module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/ltv_features_06-2334953c7c5a5937cbde88192d4133a7.png";